import { render, staticRenderFns } from "./uzytkownikdane.vue?vue&type=template&id=3d11865c&scoped=true&"
import script from "./uzytkownikdane.vue?vue&type=script&lang=js&"
export * from "./uzytkownikdane.vue?vue&type=script&lang=js&"
import style0 from "./uzytkownikdane.vue?vue&type=style&index=0&id=3d11865c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d11865c",
  null
  
)

component.options.__file = "uzytkownikdane.vue"
export default component.exports